import React, { useState, useEffect } from 'react';
import '../styles/CookieBanner.css';

function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    // Analytics will check this value before initializing
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <div className="cookie-text">
          <p>
            We use cookies to improve your experience and analyze site traffic. 
            By clicking "Accept", you consent to our use of cookies.{' '}
            <a href="/privacy" className="cookie-link">Learn more</a>
          </p>
        </div>
        <div className="cookie-actions">
          <button onClick={handleReject} className="cookie-btn cookie-btn-secondary">
            Reject
          </button>
          <button onClick={handleAccept} className="cookie-btn cookie-btn-primary">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
